
import { AUTH_ERROR, AUTH_LOADING, AUTH_LOGIN, AUTH_LOGOUT, SAVEDATA } from "./login.actionTypes";

const initialState = {
    login:false,
    error: false,

    name:"unknown",
    loading: false,
    data:[]
}



export const loginReducer = (state = initialState, { type, payload }) => {

    switch (type) {

        case AUTH_LOADING: {
            return {
                ...state,
                loading: true
            }
        }

        case AUTH_LOGIN: {
            return {
                ...state,
                login:true,
                name:payload.name,
               
                loading: false
            }
        }

        case AUTH_LOGOUT: {
            return {
                ...state,
               login:false,
                error: false,
                loading: false
            }
        }
        case SAVEDATA: {
            return{
                ...state,
                data:[...state.data,payload]

            }

        }
      

        case AUTH_ERROR: {
            return {
                ...state,
                error: true,
                loading: false
            }

        }
        default: return state;

    }

}